import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EReplyStatus, Recipient } from 'src/app/models/recipients.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { RecipientsStatusMenuComponent } from '../recipients-status-menu/recipients-status-menu.component';

@Component({
    selector: 'que-status-recipients-item',
    imports: [CommonModule, TranslateDirective, TranslatePipe, QueDatePipe, RecipientsStatusMenuComponent],
    templateUrl: './status-recipients-item.component.html',
    styleUrls: ['./status-recipients-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusRecipientsItemComponent implements OnInit {

  @Input() status?: EReplyStatus;
  #dataStore = inject(DataSummaryStore);
  answeredTheQuestionnaire$ = toSignal(this.#dataStore.answeredTheQuestionnaire$);
  status$ = signal<EReplyStatus | undefined>(undefined)
  recipientsCurrentStatus$ = computed(() => this.answeredTheQuestionnaire$()?.filter(r => this.status$() != undefined && this.status$() === r.statusReply));
  eReplyStatus = EReplyStatus;
  ngOnInit(): void {
   this.status$.set(this.status)
  }
  changeStatus(recipientId: number, firstName: string, lastName?: string) {
    this.#dataStore.changeStatus({ recipId: recipientId, recipName: `${firstName} ${lastName}` });
  }
}
